import React from 'react';
import './Basketry.css';
import { Link } from 'react-router-dom';
import basketryImage1 from '../assets/basketry1.png';
import basketryImage2 from '../assets/basketry2.png';
import basketryImage3 from '../assets/basketry3.png';
import basketryImage4 from '../assets/basketry4.png';

const Basketry = () => {
  return (
    <div className="intervention-container">
      <h1 className="section-title">Basketry Intervention</h1>

      <section className="text-block">
        <p>
          <strong>Introduction to Grasses:</strong> Grasses play essential roles in both the environment and traditional crafts. Used for centuries, they are materials for various woven products.
        </p>

        <p>
          <strong>Types of Craft Grasses:</strong><br />
          <strong>Moonj Grass:</strong> Found near riverbanks of northern India, harvested in October–November.<br />
          <strong>Sikki Grass:</strong> Known as golden grass from Bihar wetlands, harvested in monsoon.<br />
          <strong>Sabai Grass:</strong> Also called Babui grass, harvested every three months, mostly in winter.<br />
          <strong>Kusha Grass:</strong> Grows during the monsoon, also called Darbha or Pavitram.<br />
          <strong>Kaash Grass:</strong> Wild sugar cane, up to 3 meters tall, common in Ayurveda.<br />
          <strong>Palm Leaves:</strong> Durable, used for mats, baskets, roofs, and decorations.
        </p>
      </section>

      <section className="text-block">
        <p>
          Our project in Bodh Gaya—one of India’s most spiritual destinations—focuses on transforming mass-market souvenirs into meaningful handicrafts that celebrate local heritage and culture.
        </p>

        <p>
          Through the <strong>Bal Jyoti Organisation's "School of Design"</strong>, women artisans are taught modern design techniques while preserving traditional basketry using Moonj, Sikki, Sabai, Palm, Kaash, and Kusha grasses. These skills help artisans create eco-friendly items like baskets, trays, coasters, and more.
        </p>

        <p>
          These grass crafts provide rural women with sustainable income opportunities. The entire process—from drying and dyeing the grass to coiling and stitching—is done by hand. Bright dyes are often used to give a vibrant, artistic finish.
        </p>
      </section>

      {/* Image Grid Section 1 */}
      <div className="image-gallery">
        <img src={basketryImage1} alt="Basketry 1" className="gallery-image" />
        <img src={basketryImage2} alt="Basketry 2" className="gallery-image" />
      </div>

      <section className="text-block">
        <p>
          In Bodh Gaya, our project offers <strong>free training</strong> in traditional basket weaving, preserving heritage while offering a sustainable livelihood. These eco-conscious designs are helping women earn and grow with pride.
        </p>
      </section>

      {/* Image Grid Section 2 */}
      <div className="image-gallery">
        <img src={basketryImage3} alt="Basketry 3" className="gallery-image" />
        <img src={basketryImage4} alt="Basketry 4" className="gallery-image" />
      </div>

      {/* Navigation Buttons */}
      <div className="navigation-buttons">
        <Link to="/intervention/rugs" className="nav-button">Go to Rugs</Link>
        <Link to="/intervention/bamboo" className="nav-button">Go to Bamboo</Link>
        <Link to="/intervention/stitching" className="nav-button">Go to Stitching</Link>
      </div>
    </div>
  );
};

export default Basketry;
